// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Contribution } from './contribution';
import { ContributionAccount } from './contribution-account';
import { ContributionBatchNote } from './contribution-batch-note';
import { ContributionBatchStatus } from './contribution-batch-status';
import { ContributionPayment } from './contribution-payment';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ContributionBatch extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Statuses = {
        Open: 1,
        Posted: 2,
        Complete: 3,
        Void: 4,
        Error: 5,
        Review: 6,
    };

    get batchTotalAmount() {
        let total = 0;
        if (!!this.contributions) {
            this.contributions.forEach((contribution) => {
                if (!!contribution.lines) {
                    contribution.lines.forEach((line) => {
                        total += line.amount;
                    });
                }
            });
        }
        return total;
    }

    get batchTotalAmountForGeneralFund() {
        let total = 0;
        if (!!this.contributions) {
            this.contributions.forEach((contribution) => {
                if (!!contribution.lines) {
                    contribution.lines.forEach((line) => {
                        if (line.accountId === 1)
                        total += line.amount;
                    });
                }
            });
        }
        return total;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  bagNumber?: number;
  bankCashAmount?: number;
  bankCheckAmount?: number;
  created?: Date;
  createdBy?: string;
  date!: Date;
  deposited?: Date;
  modified?: Date;
  modifiedBy?: string;
  name?: string;
  note?: string;
  rowVersion?: number;
  specialAccountId?: number;
  statusId?: number;
  batchNotes!: ContributionBatchNote[];
  contributions!: Contribution[];
  payments!: ContributionPayment[];
  specialAccount!: ContributionAccount;
  status!: ContributionBatchStatus;
}

